import React from 'react';
import { Button, Tag } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import "./styles.scss"

const colors = {
  1: {
    title: 'Waiting',
    color: 'warning',
  },
  2: {
    title: 'Funded',
    color: 'gold',
  },
  3: {
    title: 'Expired',
    color: 'red',
  },
  4: {
    title: 'Rejected',
    color: 'red',
  },
  5: {
    title: 'Canceled',
    color: 'red',
  },
};

function PrintStatus({ status, fetch }) {
  if (status) {
    return (
      <div className="status_block">
        <Tag
          color={(colors[status] && colors[status].color) || 'lime'}
          className="mr-clear"
        >
          {(colors[status] && colors[status].title) || status}
        </Tag>

        {status === 1 &&  <Button type="text" size="small" onClick={fetch} icon={<ReloadOutlined />} />}
      </div>
    );
  }
  return '';
}

export default PrintStatus;
